export var OptimizelyActionTypes;
(function (OptimizelyActionTypes) {
    OptimizelyActionTypes["CHANGE_TOUR_OPERATOR_CODES"] = "CHANGE_TOUR_OPERATOR_CODES";
    OptimizelyActionTypes["INITIAL_STATE"] = "INITIAL_STATE";
})(OptimizelyActionTypes || (OptimizelyActionTypes = {}));
